export default {
    SCIP_NUMBER_TAKEN: 'product:identifier:scip-number:taken'
};
